import Enumerable from "linq";
import { DateDuration } from "../../../../domain/system";
import { StandardOption } from "../../../system/selectors/mixins";

export class DocumentDurationOptionsSource {
  public static options(): StandardOption<DateDuration>[] {
    const today = DateDuration.today();
    return [
      new StandardOption<DateDuration>("本日", today),
      new StandardOption<DateDuration>("3日間", DateDuration.fromDays(today.from, -2)),
      new StandardOption<DateDuration>("7日間", DateDuration.fromDays(today.from, -6)),
      new StandardOption<DateDuration>("1ヶ月間", DateDuration.fromMonths(today.from, -1)),
      new StandardOption<DateDuration>("3ヶ月間", DateDuration.fromMonths(today.from, -3)),
      new StandardOption<DateDuration>("すべて", new DateDuration(null, null)),
    ];
  }

  public static toDurationString(source: DateDuration): string {
    return Enumerable.from(this.options())
      .where(o => DateDuration.areEqual(o.value, source))
      .select(x => x.label)
      .firstOrDefault();
  }

  public static toDateDuration(durationName: string): DateDuration {
    return Enumerable.from(this.options())
      .where(o => o.label === durationName)
      .select(x => x.value)
      .firstOrDefault();
  }
}
